import {tfStoreView, TfStoreView} from "./view/TfStoreViewComponent";
import {TfStoreService} from "./services/TfStoreService";
import Components from "./components";

export default function(parentDir: string) {

    const rootDir = `${parentDir}/tf`;

    return angular.module("tfApp.store.tf", [Components(rootDir)])
                  .component(TfStoreView, tfStoreView(rootDir))
                  .service(TfStoreService.id, TfStoreService)
                  .name;
}
